import { createSelector } from '@reduxjs/toolkit';
import { getAvatar, getFirstName, getIsBot, getIsOnline, getIsResponderAI, getJobTitle } from 'conversations-internal-schema/responders/operators/responderGetters';
import { getAssignedResponderInWidget } from './getAssignedResponderInWidget';
import I18n from 'I18n';
// Single entry point for "who's the assigned responder, as display props" —
// used by any popup that represents a specific agent/responder.
export const getResponderDisplayData = createSelector([getAssignedResponderInWidget], responder => ({
  agentName: responder && getFirstName(responder) || I18n.text('conversations-visitor-ui.default.agent'),
  agentJobTitle: responder && getJobTitle(responder) || null,
  agentAvatarUrl: responder && getAvatar(responder) || undefined,
  isBot: Boolean(responder && getIsBot(responder)),
  isResponderAI: Boolean(responder && getIsResponderAI(responder)),
  isOnline: Boolean(responder && getIsOnline(responder))
}));